<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hnup5Z/tc-custom/9781398496750.jpg?1720272536407" alt="This image is the cover for the book Audrey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Audrey
      </h1>
      <p class="bookDescription body article font2">
        <p>‘Hello?’ ‘I bet anything that you are pacing up and down right now, thinking of excuses to cancel on me tonight. Am I right?’ It’s Veronica. Audrey looks out the window as if expecting to see Veronica with a pair of binoculars. ‘No!’ Audrey is not at all surprised at how well Veronica knows her. ‘Great, pick you up in fifteen, babe. Mwah.’ Audrey Mills resides in New York City, The Parkway, a grand old building that has become home for Audrey, for almost four years. Known to be somewhat of a recluse, Audrey works at a small florist just a few blocks from where she lives, and except for a few close friends, she generally prefers to keep to herself, spending most of her spare time reading and playing her grandmother’s piano. As Audrey stands there, mesmerised by the intricacy of the artwork, she is entirely unaware that a stealthy William has walked up behind her. With his eyes fixated on her flawless profile, William allows several moments to pass before deciding to announce his presence.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Cranberry
      </h2>
      
      <p class="authorDescription body article">John Cranberry was born and raised in Sydney, Australia. Although he did not excel in school due to undiagnosed dyslexia, he did excel in subjects like photography and art that required his creativity and imagination to shine. His creative writing began as early as high school, writing adventurous letters and passing them onto his dear friend, Kat, between classes for her amusement. Later in life, John decided to put pen to paper for the first time in over a decade, determined to write his first novel. He had an unfulfilled passion to express himself through his creative writing once again, but this time, he aimed to reach a greater audience. This is when Audrey was conceived.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?529554a8